module.exports = __webpack_public_path__ + "img/soldier-logo.fb290176.png";